/*
 * @Author: your name
 * @Date: 2020-06-04 08:59:14
 * @LastEditTime: 2020-06-29 11:34:19
 * @LastEditors: Please set LastEditors
 * @FilePath: \Parts_Web\src\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import constant from './constant'
import maintain from './maintain'

export const asyncRoutes = [].concat(
    maintain
)
export const constantRoutes = constant.concat(
    asyncRoutes
)
// export const lastRouterMap = [
//     { path: '*', redirect: '/404', hidden: true, meta: { menuid: '404' }}
// ]
const createRouter = () => new Router({
    mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
})
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};
const router = createRouter()

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher
}

export default router
